import React from "react";
import { Link } from "react-router-dom";

const Breadcrumb = ({ Title, Subtitle }) => {
    return (
        <>
            <div className="bred_crumb">
                <div className="container">
                    <span className="banner_shape1">
                        
                       
                    </span>
                    <span className="banner_shape2">
                      
                    </span>
                    <div className="bred_text">
                        <h1>{Title}</h1>
                        <ul>
                            <li>
                                <Link to="/">Home</Link>
                            </li>
                            <li>
                                <span>»</span>
                            </li>
                            <li>
                                <span>{Subtitle}</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

        </>
    )
}
export default Breadcrumb;